import { Injectable } from "@angular/core";
import { APIServiceProvider } from "../api.service";
import { SocketioService } from "../socketio.service";
import { HelperServiceProvider } from "./../helper.service";

@Injectable()
export class NotificationsService {
  public states = null;

  public newNotifications = 0;
  public notifications = [];
  public allNotifications = [];
  public nextPage = null;
  public url = "notifications/get-notifications";
  public notificationTypes = [];
  public filters = {
    notification_type: null
  };
  public postParams = {};

  public checkAll: any;

  public updateMultiType = {
    viewed: false,
    important: false
  };
  public disableSubmit = false;
  public notificationsSelected = false;
  public showActionBtns = true;

  constructor(
    public apiHelper: APIServiceProvider,
    public helperService: HelperServiceProvider,
    public socketService: SocketioService
  ) {
    this.socketService.socket.on("notification", notification => {
      this.newNotifications++;
      notification.created_date = new Date(notification.created_at);

      this.notifications.unshift(notification);
      this.allNotifications.unshift(notification);
      if (this.notifications.length > 3) {
        this.notifications.pop();
      }
    });
    this.getNotifications(this.url);
    this.getNotificationTypes();
  }

  getNotifications(url, filered?, paginate?) {
    this.apiHelper.post(url, this.postParams, paginate).subscribe(
      result => {
        this.newNotifications = result["meta"]["unread"];
        this.nextPage = result["data"]["next_page_url"];
        if (!paginate) {
          this.allNotifications = [];
        }
        result["data"]["data"].forEach(e => {
          e.payload.created_date = new Date(e.payload.created_at);
          this.allNotifications.push(e.payload);
          if (!filered) {
            this.notifications.push(e.payload);
            if (this.notifications.length > 3) {
              this.notifications.pop();
            }
          }
        });
      },
      err => {
        console.log(err);
      }
    );
  }

  pulltoRefresh(refresher) {
    this.filters["notification_type"] = null;
    this.postParams = {};
    this.getNotifications(this.url, true);
    refresher.complete();
  }

  filterNotifications() {
    if (
      this.filters["notification_type"] &&
      this.filters["notification_type"].length > 0
    ) {
      this.postParams["notification_type"] = this.filters["notification_type"];
    } else {
      delete this.postParams["notification_type"];
    }
    this.getNotifications(this.url, true);
  }

  paginate() {
    if (this.nextPage) {
      this.getNotifications(this.url, null, this.nextPage);
    }
  }

  getNotificationTypes() {
    this.apiHelper.get("notifications/get-notification-types").subscribe(
      result => {
        this.notificationTypes = result["data"];
      },
      err => {
        console.log(err);
      }
    );
  }

  updateStatus(notification, type, forceUpdate?) {
    const params = {
      notification_id: notification["notification_id"]
    };
    params[type] = null;
    if (forceUpdate) {
      params[type] = true;
    }
    this.apiHelper
      .post("notifications/update-notification-status", params)
      .subscribe(
        result => {
          this.newNotifications = result["meta"]["unread"];
          this.allNotifications.map(e => {
            if (e.notification_id === notification["notification_id"]) {
              e[type] = result["data"][type];
            }
            return e;
          });

          this.notifications.map(e => {
            if (e.notification_id === notification["notification_id"]) {
              e[type] = result["data"][type];
            }
            return e;
          });
        },
        err => {
          console.log(err);
        }
      );
  }

  updateMultipleNotifications(type) {
    let params = {};
    params["notification_ids"] = this.allNotifications
      .filter(e => e.selected === true)
      .map(e => e.notification_id);
    params[type] = !this.updateMultiType[type];
    this.updateMultiType[type] = !this.updateMultiType[type];
    this.apiHelper
      .post("notifications/update-multiiple-notification-status", params)
      .subscribe(result => {
        this.newNotifications = result["meta"]["unread"];
        this.allNotifications.filter(e => e.selected === true).map(e => {
          e[type] = params[type];
          return e;
        });
        let toastMessage = null;
        if (type === "viewed") {
          toastMessage = this.updateMultiType[type] ? "read" : "unread";
        } else if (type === "important") {
          toastMessage = this.updateMultiType[type]
            ? "important"
            : "not important";
        }
        const notificationsCount = params["notification_ids"].length;

        this.helperService.presentToast(
          `${notificationsCount} notification'(s) marked as ${toastMessage}.`
        );
      });
  }

  markAllAsRead() {
    this.disableSubmit = true;
    this.apiHelper.post("notifications/mark-all-as-read").subscribe(
      result => {
        this.helperService.presentToast(
          "All notifications are marked as read."
        );
        this.disableSubmit = false;
        this.newNotifications = 0;
        this.notifications.map(e => {
          e["viewed"] = true;
          return e;
        });
        this.allNotifications.map(e => {
          e["viewed"] = true;
          return e;
        });
      },
      err => {
        this.disableSubmit = false;
        console.log(err);
      }
    );
  }

  notificationSelected() {
    this.showActionBtns =
      this.allNotifications.filter(e => e.selected === true).length > 0
        ? false
        : true;
  }

  selectAllNotifications(selected) {
    this.allNotifications.map(e => {
      e["selected"] = selected;
      return e;
    });
    this.notificationSelected();
  }

  clearFilters() {
    this.filters["notification_type"] = null;
    this.postParams = {};
    this.getNotifications(this.url, true);
  }
}
  
  



// WEBPACK FOOTER //
// ./src/common/services/notifications/notifications.service.ts